// extracted by mini-css-extract-plugin
export var black = "_2z-6";
export var brand = "_2z-1";
export var ddefault = "_2z-0";
export var error = "_2z-3";
export var gray = "_2z-2";
export var highContrast = "_2z-8";
export var outline = "_2z-7";
export var success = "_2z-5";
export var warning = "_2z-4";